import {useEffect, useState} from "react";

export default function Clock() {
    const [now, setNow] = useState<Date>(new Date());

    useEffect(() => {
        const interval = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="clock" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{paddingTop: '5px'}}>
                <img alt="clock" src="small-clock.png" style={{height: '18px', paddingRight: '10px'}}/>
            </div>
            <div style={{fontSize: '18px'}}>
                {now.getHours().toString().padStart(2,'0')}:{now.getMinutes().toString().padStart(2,'0')}:{now.getSeconds().toString().padStart(2,'0')} CET
            </div>
        </div>
    )
}
